import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useClientSide } from '../../hooks/useClientSide';
import { useEventListener } from '../../hooks/useEventListener';
import { useWindowSize } from '../../hooks/useWindowSize';

const HorizontalScroll = ({ children, className }) => {
  const isClient = useClientSide();
  const size = useWindowSize();

  const [dynamicHeight, setDynamicHeight] = useState(null);
  const [translateX, setTranslateX] = useState(0);

  const containerRef = useRef(null);
  const objectRef = useRef(null);

  useEffect(() => {
    const calcDynamicHeight = (width) => {
      const vw = isClient && window.innerWidth;
      const vh = isClient && window.innerHeight;
      return width - vw + vh + 150;
    };

    const objectWidth = objectRef.current.scrollWidth;
    const dynHeight = calcDynamicHeight(objectWidth);
    setDynamicHeight(dynHeight);
  }, [size, isClient]);

  useEventListener(
    'scroll',
    () => {
      const offsetTop = -containerRef.current.offsetTop;
      setTranslateX(offsetTop);
    },
    isClient && window
  );

  return (
    <StyledHorizontalScroll
      style={{ height: `${dynamicHeight}px` }}
      className={className}
    >
      <div ref={containerRef} className="inner">
        <div
          className="horizontal-container"
          ref={objectRef}
          style={{ transform: `translateX(${translateX}px)` }}
        >
          {children}
        </div>
      </div>
    </StyledHorizontalScroll>
  );
};

const StyledHorizontalScroll = styled.section`
  position: relative;
  width: 100%;

  .inner {
    position: sticky;
    top: 0;
    height: 100vh;
    width: 100%;
    overflow-x: hidden;
  }

  .horizontal-container {
    position: absolute;
    height: 100%;
    will-change: transform;
  }
`;

HorizontalScroll.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default HorizontalScroll;
